import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("co_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const STAGES = ["Idea", "Script", "Voiceover", "Editing", "Thumbnail", "Scheduled", "Published"];

export const CHANNEL_COLORS = ["#D9A441", "#4182D9", "#2E8B57", "#B565D9", "#D9683D", "#3DB9D9"];

export function channelColor(id, channels) {
  const idx = channels.findIndex((c) => c.id === id);
  return CHANNEL_COLORS[idx % CHANNEL_COLORS.length] || "#A0A0A5";
}

export default api;
